import { useTheme } from '@emotion/react'
import { Button, Card, CardActions, CardContent, CardHeader, Divider, Stack, Tooltip, Box, Typography } from '@mui/material'
import { DevicesIcon } from 'components/Icons'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { hasFullPermission } from 'store'

export default function PreviewCard({
  children,
  title,
  titleSize = 'h6',
  buttonLabel,
  buttonNavigate,
  buttonDisabled,
  buttonColor,
  otherButton,
  size,
  actionChildren,
  onlyReadable,
  buttonClick,
  buttonPermission
}) {
  const theme = useTheme()
  const themeMode = useSelector(state => state.session.appearance)
  const navigate = useNavigate();

  const actions = []
  if (otherButton) {
    actions.push(otherButton)
  }
  if (!onlyReadable && buttonNavigate) {
    actions.push({ buttonLabel, buttonNavigate, buttonDisabled, buttonColor, buttonClick, buttonPermission })
  }

  const handleButtonClick = act => e => {
    if (act.buttonClick) {
      act.buttonClick(e) // Custom handler runs first
    }
    if (act.buttonNavigate) {
      navigate(act.buttonNavigate) // Safe fallback navigation
    }
  }

  const permittedActions = actions.filter(act => {
  if (!act.buttonPermission) return true;
  return hasFullPermission(act.buttonPermission);
});

  return (
    <Stack alignItems="stretch" sx={{ height: '100%' }}>
      <Card
        sx={{
          width: size === 'small' ? '50%' : '100%',
          height: '100%',
          borderRadius: '5px',
          boxShadow: 'none !important',
          border: themeMode === 'dark' ? 'none' : '1px solid',
          borderColor: theme.palette.action.disabled,
        }}
      >
        <CardHeader
          title={title}
          titleTypographyProps={{ variant: titleSize, fontWeight: 500 }}
          sx={{ px: 3 }}
          action={permittedActions.map((act, ind) => (
            <Button
              key={ind}
              size="small"
              disabled={act.buttonDisabled}
              onClick={handleButtonClick(act)}
              variant="contained"
              color={act.buttonColor || 'primary'}
              sx={{ /* borderRadius: '20px', */ mr: 1, mt: 0.5 }}
            // disableElevation={true}
            >
              {act.buttonLabel}
            </Button>
          ))}
        />
        <Divider />
        <CardContent sx={{ px: 3 }}>{children}</CardContent>
        {actionChildren && (
          <>
            <Divider />
            <CardActions sx={{ p: 2, display: 'flex', flexWrap: 'wrap' }}>{actionChildren}</CardActions>{' '}
          </>
        )}
      </Card>
    </Stack>
  )
}

export const AssignedAssets = ({ assets = [] }) => {
  const { t } = useTranslation()

  if (!assets.length) return null

  return (
    <Tooltip
      placement="bottom"
      title={
        <Box sx={{ py: 0.5, minWidth: 200 }}>
          <Typography variant="caption" sx={{ display: 'block', opacity: 0.75, mb: 0.5 }}>
            {t('Assigned Assets')}
          </Typography>

          {assets.map((asset, index) => (
            <Box key={asset.assetNumber ?? index}>
              {index > 0 && <Divider sx={{ my: 0.75, borderColor: 'currentColor', opacity: 0.25 }} />}
              <Typography variant="body2" fontWeight={700}>
                {asset.type ?? asset.typeId}
                {asset.brand ? ` · ${asset.brand}` : ''}
              </Typography>
              <Typography variant="caption" sx={{ display: 'block', opacity: 0.85 }}>
                {[asset.assetNumber, asset.serialNumber].filter(Boolean).join('  ·  ')}
              </Typography>
              {asset.status && (
                <Typography variant="caption" sx={{ display: 'block', opacity: 0.85 }}>
                  {t('Status')}: {asset.status} {t('on')} {asset.assignedDate}
                </Typography>
              )}
            </Box>
          ))}
        </Box>
      }
    >
      <DevicesIcon fontSize="medium" color='primary' />
    </Tooltip>
  )
}